import { Box, Divider, IconButton, Typography, useMediaQuery } from '@mui/material';
import FilterComponentV2 from '../../components/TablegridWithFilters/FilterComponent/FilterComponentv2';
import { AppleTitleNamingKeys, Ilevels } from '../../lib/generalTypes';
import { useEffect, useState } from 'react';
import HttpService from '../../services/HttpService';
import CardGrid from '../../components/CardGrid';
import { useSearchParams, createSearchParams, useNavigate } from 'react-router-dom';
import { createSearchParamsFormat, GetSortOrder, maxValidationString, splitStringByDashAndCapitalizeFirstLetterOfEachWord, transformGreekToEnglish } from '../../lib/helperFuncs';
import { ISortingFilters } from '../../components/Tag/types';
import { useTranslation } from 'react-i18next';
import { ImageItem } from '../../components/Cards/Types';
import { useSnackbar } from 'notistack';
import * as Yup from 'yup';
import UserService from '../../services/UserService';
import { Permissions } from '../../lib/permissions';
import Theme from '../../Themes/main.theme';
import LinkButton from '../../components/Buttons/LinkButton';
import i18n from '../../i18n';
import { useFromAccessLogic } from '../../hooks/useFromAccessLogic';

const ITEMS_PER_PAGE = 16;

const initialValues1 = {
  free_text: '',
  level1: '',
  level2: '',
  regions: ''
};


const validationSchema = Yup.object({
  free_text:
    Yup.string().max(60, maxValidationString(60)),
});

const Professionals = () => {
  const [regions, setRegions] = useState([]);
  const [level1Options, setlevel1Options] = useState([]);
  const [specialties, setSpecialties] = useState([]);
  const [omekaResults, setOmekaResults] = useState<ImageItem[]>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [initialValues, setInitialValues] = useState(initialValues1);
  const [favoriteError, setFavoriteError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedPage, setSelectedPage] = useState<number>(1);
  const [totalResults, setTotalResults] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string | undefined>('1');

  const matchesXSbreakpoint = useMediaQuery('(max-width:768px)');
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { availableForms, isLoading: isFormPublishedLoading } =
  useFromAccessLogic(AppleTitleNamingKeys.ProfessionalRegister);

  document.title = t('Αναζήτηση Επαγγελματιών');

  const filterFields = (
    regions: Ilevels[],
    level1Options: Ilevels[],
    specialties: Ilevels[]
  ) => {
    const fullScreen = [
      [{
        control: 'input',
        name: 'free_text',
        type: 'search',
        placeholder: t('Πληκτρολογήστε'),
        takeFullLine: true,
        filtersDesign: true,
        fullWidth: true,
        endAdornment: <IconButton component='label'>
          <input hidden accept='image/*'
            type='file' />
        </IconButton>
      }],
      [
        {
          control: 'autocomplete',
          label: t('Περιφέρειες / Δήμοι'),
          name: 'regions',
          id: 'regions',
          filtersDesign: true,
          disabled: searchParams.get('locked')?.includes('regions'),
          options: regions
        },
        {
          control: 'autocomplete',
          label: t('Κατηγορία Υπηρεσιών'),
          name: 'level1',
          filtersDesign: true,
          options: level1Options
        },
        {
          control: 'multiselecttree',
          label: t('Ειδικότητα'),
          name: 'level2',
          filtersDesign: true,
          options: specialties
        }
      ]
    ];
    const mobileFilter = [
      {
        control: 'input',
        name: 'free_text',
        type: 'search',
        placeholder: t('Πληκτρολογήστε'),
        takeFullLine: true,
        filtersDesign: true,
        fullWidth: true,
        endAdornment: <IconButton component='label'>
          <input hidden accept='image/*'
            type='file' />
        </IconButton>
      },
      {
        control: 'autocomplete',
        label: t('Περιφέρειες / Δήμοι'),
        name: 'regions',
        id: 'regions',
        filtersDesign: true,
        disabled: searchParams.get('locked')?.includes('regions'),
        options: regions
      },
      {
        control: 'autocomplete',
        label: t('Κατηγορία Υπηρεσιών'),
        name: 'level1',
        filtersDesign: true,
        options: level1Options
      },
      {
        control: 'multiselecttree',
        label: t('Ειδικότητα'),
        name: 'level2',
        filtersDesign: true,
        options: specialties
      }
    ];
    return matchesXSbreakpoint
      ? mobileFilter
      : fullScreen;
  };

  const sortingItems: ISortingFilters[] | undefined = [{
    id: '1',
    refValue: 'title',
    sortOrder: 'asc',
    label: t('Αλφαβητικά')
  }, {
    id: '2',
    refValue: 'locations:locationsCategory',
    sortOrder: 'asc',
    label: t('Κατηγορία'),
  },
  {
    id: '3',
    refValue: 'created',
    sortOrder: 'desc',
    label: t('Νεότερης Καταχώρισης'),
  },
  {
    id: '4',
    refValue: 'professionals:professionalRegion',
    sortOrder: 'asc',
    label: t('Περιφερειακή Ενότητα'),
  }];

  const onSubmitFavorite = async (id: number, isFavorite: boolean) => {
    if (!UserService.isAuthenticated()) {
      enqueueSnackbar(t('Πρέπει να είστε συνδεδεμένος για να προσθέσετε τοποθεσία στα αγαπημένα σας'), { variant: 'error' });
      navigate('/');
      return;
    }
    try {
      const resp = await HttpService.getAxiosClient().patch(`${process.env.REACT_APP_BACKEND_URL}/professionals/favorites/${id}`, { is_favorite: isFavorite });
      if (resp.status === 200) {
        setOmekaResults(omekaResults);
        
        if (resp.data.is_favorite === true) {
          enqueueSnackbar(`${t('O επαγγελματίας')} ${i18n.language === 'en'
            ? transformGreekToEnglish(`${resp.data.title}`)
            : resp.data.title} ${t('προστέθηκε στα αγαπημένα σας')}`, { variant: 'success' });
        } else {
          enqueueSnackbar(`${t('O επαγγελματίας')} ${i18n.language === 'en'
            ? transformGreekToEnglish(`${resp.data.title}`)
            : resp.data.title} ${t('αφαιρέθηκε από τα αγαπημένα σας')}`, { variant: 'info' });
        }
      }
    } catch (error) {
      setFavoriteError(!favoriteError);
      console.error(error);
      enqueueSnackbar(t('Παρουσιάστηκε σφάλμα, παρακαλούμε προσπαθήστε αργότερα.'), { variant: 'error' });
    }
  };

  const constructUrlSortingFilterParams = (sortingItemId?: string, page?: number) => {
    const filterParameters = sortingItems?.find((x: any) => x.id === sortingItemId);
    for (const entry of searchParams.entries()) {
      const [param] = entry;
      if (param === 'sort_by') {
        searchParams.delete('sort_by');
        searchParams.delete('per_page');
        searchParams.delete('page');
        searchParams.delete('sort_order');
        setSearchParams(searchParams);
      }
    }
    const sortingParams = createSearchParams(
      {
        sort_by: `${filterParameters?.refValue}`,
        sort_order: `${filterParameters?.sortOrder}`,
        page: page
          ? `${page}`
          : `${selectedPage}`,
        per_page: `${ITEMS_PER_PAGE}`
      })
      .toString();
    setSearchParams(`${searchParams.toString()}&${sortingParams}`);
  };

  const handleSortingChange = (sortingItemId: string) => {
    constructUrlSortingFilterParams(sortingItemId);
    setSortBy(sortingItemId);
  };

  const handleOnPageChange = (page: number) => {
    setSelectedPage(page);
    constructUrlSortingFilterParams(sortBy, page);
  };

  const onSubmit = (values: any) => {
    const x = createSearchParamsFormat(values);
    Object.keys(initialValues).map((value) => {
      searchParams.delete(value);
      setSearchParams(searchParams);
    });
    setSearchParams(`${searchParams.toString()}&${createSearchParams(x).toString()}`);
  };

  const fetchProfessionals = async () => {
    const link = searchParams.toString() && `&${searchParams.toString()}`;
    const filterParameters = sortingItems?.find((x: any) => x.id === sortBy);
    const sortingParams = createSearchParams(
      {
        ...(!searchParams.has('sort_by') &&
        {
          sort_by: `${filterParameters?.refValue}`
        }),
        ...(!searchParams.has('sort_order') && {
          sort_order: `${filterParameters?.sortOrder}`
        }),
        ...(!searchParams.has('page') && {
          page: `${selectedPage}`
        }),
        ...(!searchParams.has('per_page') && {
          per_page: `${ITEMS_PER_PAGE}`
        })
      })
      .toString();
    try {
      setIsLoading(true);
      const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/professionals?is_public=1&crm=&${link}&${sortingParams}`);
      const response_ids = resp.data.records.map((x:any)=> x['o:id']); 

      if (UserService.isAuthenticated()) {
        const resp_favorites = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/professionals/favorites?professionals_ids=${response_ids}`);
        const favorites = resp_favorites.data.filter((x: any) => 
          x.is_favorite === true).map((x: any) => {      
          return {
            is_favorite: x.is_favorite,
            id: x.id
          };
        });
    
        const updatedRecords = resp.data.records.map((item: any) => {       
          const favorite = favorites.find((fav: any) => fav.id === item['o:id']);            
          if (favorite) {
            return {
              ...item,
              is_favorite: favorite.is_favorite,
              id: favorite.id,
            };
          }
          return item;
        });
    
        resp.data.records = updatedRecords;   
      } 
      const shouldDisplayFavoriteIcon = UserService.isAuthenticated() &&
        UserService.hasRole([Permissions.PermissionExternalProfessionalsFavoritesUpdateMy]);
      const results: ImageItem[] = resp.data.records.map((x: any) => {
        return {
          id: x['o:id'],
          title: x['o:title'],
          img: x.thumbnail_display_urls.large,
          subtitle: x?.['professionals:professionalRegion']?.[0]?.['@value'],
          alwayShowBanner: true,
          favorite: x.is_favorite,
          displayFavorite: shouldDisplayFavoriteIcon,
          redirect: 'professionals/details'
        };
      });
      setTotalResults(resp.data.totalResults);
      setOmekaResults(results);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const getRegions = async () => {
    const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/locations/parametrics/regions-search`);
    const options = resp?.data['o:terms'].map((location: any) => {
      return {
        key: t(location.key),
        value: location.value
      };
    });
    setRegions(i18n.language === 'en'
      ? options.sort(GetSortOrder('key'))
      : options.sort((a: any, b: any) => a.key.localeCompare(b.key, 'el')));
  };

  const getLevel1Options = async () => {
    const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/professionals/parametrics/services`);
    const options = resp?.data.map((location: any) => {
      return {
        key: t(location),
        value: location
      };
    });
    setlevel1Options(i18n.language === 'en'
      ? options.sort(GetSortOrder('key'))
      : options.sort((a: any, b: any) => a.key.localeCompare(b.key, 'el')));
  };

  const getSpecialties = async () => {
    const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/professionals/parametrics/specialties`);
    const options_level_2 = resp?.data?.level2?.data?.map((location: any) => {
      const x = location?.['dcterms:relation'];
      if (!x) return;
      return {
        key: t(location?.['o:title']),
        value: location?.['o:id'],
        parent: t(x[0].display_title)
      };
    }).filter((value: any) => value);
    setSpecialties(i18n.language === 'en'
      ? options_level_2.sort(GetSortOrder('parent'))
      : options_level_2.sort((a: any, b: any) => a.parent.localeCompare(b.parent, 'el')));
  };

  useEffect(() => {
    Promise.all([
      getRegions(),
      getLevel1Options(),
      getSpecialties()
    ]);
  }, []);

  useEffect(() => {
    let _params = { ...initialValues1 };
    for (const entry of searchParams.entries()) {
      const [param, value] = entry;
      if (searchParams.has(param) && param in initialValues1) {
        if (param === 'free_text') {
          _params = { ..._params, [param]: value };
        } else {
          const _x = value.split(',').map((valueOfParam: any) => {
            return {
              key: valueOfParam,
              value: valueOfParam
            };
          });
          _params = { ..._params, [param]: _x };
        }
      }
    }
    setInitialValues({ ..._params });
    fetchProfessionals();
  }, [searchParams, favoriteError]);


  // useEffect for initialValues of filters & tags & sorting based on searchParams
  useEffect(() => {
    let _params = { ...initialValues };
    for (const entry of searchParams.entries()) {
      const [param, value] = entry;
      if (param === 'regions') { // we need this handling cause wordpress is not able to capitalize the first letter of the region
        const x = value.split(',');
        const _x = x.map((valueOfParam: any) => {
          return {
            key: splitStringByDashAndCapitalizeFirstLetterOfEachWord(valueOfParam),
            value: splitStringByDashAndCapitalizeFirstLetterOfEachWord(valueOfParam)
          };
        });
        _params = { ..._params, [param as any]: _x };

      }
      else if (param === 'free_text') {
        _params = { ..._params, [param]: value };
      } else if (param === 'sort_by') {
        const sort = sortingItems.find(item => item.refValue === value);
        setSortBy(sort?.id);
      } else {
        const x = value.split(',');
        const _x = x.map((valueOfParam: any) => {
          return {
            key: valueOfParam,
            value: valueOfParam
          };
        });
        _params = { ..._params, [param]: _x };
      }
    }
    setInitialValues({ ..._params });
  }, []);


  const clearFilters = () => {

    searchParams.delete('free_text');
    searchParams.delete('level1');
    searchParams.delete('level2');
    searchParams.delete('regions');
    searchParams.delete('is_public');
    searchParams.delete('crm');
    searchParams.delete('order');
    searchParams.delete('page');
    searchParams.delete('page_length');

    setSearchParams(searchParams);

  };

  return (<>
    {!isFormPublishedLoading && availableForms.is_published 
      ? <Box display='flex' justifyContent='flex-end'
        mr={1} mb={5}>
        <LinkButton
          disabled={!UserService.hasRole(
            [Permissions.PermissionExternalProfessionalApplicationCreateMy])}
          link='/professionals/new' variant='contained'
          tooltipTitle={!UserService.hasRole(
            [Permissions.PermissionExternalProfessionalApplicationCreateMy])
            ? t('Επιλέξτε Είσοδο στο Σύστημα μέσω πιστοποίησης από την ΑΑΔΕ για να μπορέσετε να καταχωρίσετε έναν επαγγελματία.')
            : ''}
          sx={{ borderRadius: '24px' }}>
          {t('Καταχώριση Επαγγελματία')}
        </LinkButton>
      </Box>
      : null
    }
    <FilterComponentV2
      title={<Typography variant='h2' sx={{ mt: 3 }}
        color={Theme.labelColor?.main}>
        {t('Επαγγελματίες')}
      </Typography>}
      validationSchema={validationSchema}
      filterFields={filterFields(regions, level1Options, specialties)}
      initialValues={initialValues}
      resetFilters={true}
      onResetFunction={clearFilters}
      resetFiltersTo={initialValues1}
      changeFilters={filterValues => onSubmit(filterValues)}
    />
    <Divider sx={{ my: 3 }} />
    <CardGrid
      grid={{
        gridData: omekaResults,
        onTagClick: () => undefined,
        onSubmitFavorite: onSubmitFavorite
      }}
      isLoading={isLoading}
      pagination={{
        serverSidePagination: false,
        itemsPerPage: ITEMS_PER_PAGE,
        totalResults: totalResults,
        selectedPage: selectedPage,
        handleOnPageChange: handleOnPageChange
      }}
      sorting={{
        clientSideSorting: false,
        handleSortingChange: handleSortingChange,
        defaultValue: sortBy,
        sortingItems: sortingItems
      }}
    />
  </>);
};

export default Professionals;